var React = require('react');

function ChevronLeftLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 47L0.999999 24L20 0.999998","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronLeftLarge.defaultProps = {"width":"21","height":"48","viewBox":"0 0 21 48","fill":"none"};

module.exports = ChevronLeftLarge;

ChevronLeftLarge.default = ChevronLeftLarge;
